<!-- 更改关联弹框 -->
<template>
    <el-dialog @close="close" title="更改关联" :visible.sync="centerDialogVisible" width="70%" center>
        <div style="font-size: 0.3rem;margin-bottom: 0.3rem;">
            发票金额: <span style="color: red;font-weight: bold;">¥{{ price }}</span>
        </div>
        <div style="font-size: 0.2rem;margin-bottom: 0.1rem;">已关联收款订单:</div>
        <div
            style="padding: 20rpx;border-radius: 20rpx;box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;margin-bottom: 0.3rem;">
            <el-table :data="detailLinkList">
                <el-table-column align="center" prop="planId" label="团号">
                </el-table-column>
                <el-table-column align="center" prop="nameOfPayee" label="收款方名称">
                </el-table-column>
                <el-table-column align="center" prop="orderId" label="订单id">
                </el-table-column>
                <el-table-column align="center" prop="price" label="已开票金额">
                </el-table-column>
                <el-table-column align="center" prop="price" label="操作">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" @click="deleteLink(scope.row)">删除关联</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="font-size: 0.2rem;margin-bottom: 0.1rem;">未关联收款订单:</div>

        <header class="header">
            <p class="headerP1">筛选</p>
            <div style="height:0.34rem;border-right:1px solid #53B0A3;width: 1px;margin-right: 0.24rem;"></div>
            <el-input size="small" type="number" style="width: 1rem;margin-right: 0.1rem;"
                v-model="pageRequest.q.planId" placeholder="团号"></el-input>
            <el-input size="small" type="number" style="width: 1rem;margin-right: 0.1rem;" v-model="pageRequest.q.id"
                placeholder="id"></el-input>
            <el-input size="small" style="width: 1rem;margin-right: 0.1rem;" v-model="pageRequest.q.chargingContent"
                placeholder="收款内容"></el-input>
            <el-input size="small" style="width: 1rem;margin-right: 0.1rem;" v-model="pageRequest.q.payName"
                placeholder="付款方名称"></el-input>
            <el-input size="small" style="width: 1.8rem;margin-right: 0.1rem;" v-model="pageRequest.q.collectionId"
                placeholder="订单编号"></el-input>
            <el-date-picker @change="pageRequest.page = 1, getList()" value-format="yyyy-MM-dd" size="small"
                style="margin-right: 0.1rem;width: 1.5rem;" v-model="pageRequest.q.payDateStr" type="date"
                placeholder="选择日期">
            </el-date-picker>
            <el-input size="small" type="number" style="width: 1.2rem;margin-right: 0.1rem;"
                v-model="pageRequest.q.payPrice" placeholder="收款金额"></el-input>
            <el-select @change="pageRequest.page = 1, getList()" size="small"
                style="width: 1.2rem;margin-right: 0.1rem;" v-model="pageRequest.q.payType" placeholder="付款方式">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-button size="small" @click="page = 1, getList()" type="primary" icon="el-icon-search">查询</el-button>
            <el-button size="small" @click="resetClick" icon="el-icon-search">重 置</el-button>
        </header>
        <div
            style="padding: 20rpx;border-radius: 20rpx;box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;margin-bottom: 0.3rem;">
            <el-table v-loading="loading" border @select-all="handleSelectionChange" @select="handlerSelectChange"
                :header-cell-style="{ backgroundColor: '#F1FAF9', color: '#000000' }" ref="multipleTable"
                :data="tableData" tooltip-effect="dark" style="width: 100%">
                <el-table-column :selectable="selectable" fixed="left" align="center" type="selection" width="55">
                </el-table-column>
                <el-table-column fixed="left" width="180" prop="planId" align="center" label="团号">
                    <template slot-scope="scope"> {{ scope.row.order.planId }} </template>
                </el-table-column>
                <el-table-column fixed="left" width="180" align="center" label="收款内容">
                    <template slot-scope="scope"> {{ scope.row.order.chargingContent }} </template>
                </el-table-column>
                <el-table-column width="200" align="center" label="收款时间">
                    <template slot-scope="scope"> {{ scope.row.payDate | dateFormat }} </template>
                </el-table-column>
                <el-table-column width="250" prop="payName" align="center" label="付款方名称"> </el-table-column>
                <el-table-column width="180" prop="payPrice" align="center" label="金额"> </el-table-column>
                <el-table-column width="180" prop="refundPrice" align="center" label="退款金额"> </el-table-column>
                <el-table-column width="180" prop="actualArrival" align="center" label="实际到帐金额">
                </el-table-column>
                <el-table-column width="100" align="center" label="已开票金额">
                    <template slot-scope="scope">
                        {{ scope.row.invoicePrice ? '¥' + scope.row.invoicePrice : '未开票' }}
                    </template>
                </el-table-column>
                <el-table-column width="180" prop="refundPrice" align="center" label="退款提请金额">
                    <template slot-scope="scope"> {{ Number(scope.row.refundPrice) }} </template>
                </el-table-column>
                <el-table-column width="150" align="center" label="付款方式">
                    <template slot-scope="scope"> {{ scope.row.payType == 1 ? '微信' : '线下转账' }} </template>
                </el-table-column>
                <el-table-column width="150" align="center" label="备注">
                    <template slot-scope="scope"> {{ scope.row.remark }} </template>
                </el-table-column>
            </el-table>
            <pagination :pageSizes="pageSizes" :totalNumber="total" @loadTable="loadTable"></pagination>
        </div>
        <div style="margin-top: 30px;text-align: center;color: red;font-size: 0.2rem;font-weight: bold">
            注：如需重新关联，请先删除已关联的数据
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确定关联</el-button>
        </span>
    </el-dialog>
</template>

<script>
import Api from "@/components/Api";
import PayApi from "@/components/Api/pay";
import Pagination from "@/components/Pagination";
import { uniqueByProperty } from '@/assets/utils/unit'
export default {
    components: {
        Pagination
    },
    data() {
        return {
            loading: false,
            price: 0,//发票金额
            centerDialogVisible: false,
            detailLinkList: [],//关联数据
            tableData: [],//未关联的数据
            multipleSelection: [],//选择的未关联数据
            invoicingDetailId: null,
            pageSizes: [10, 20, 30, 40, 50],
            total: 0,
            options: [{
                value: 1,
                label: '微信支付'
            }, {
                value: '2',
                label: '线下转账'
            },],
            pageRequest: {
                page: 1,
                size: 10,
                q: {
                    planId: '',
                    chargingContent: '',//收款内容
                    payDateStr: '',//收款时间
                    payName: '',//付款方名称
                    payType: '',//付款方式 1微信 2线下
                    payPrice: null,//收款金额
                    id: null,
                    collectionId: null
                }
            },
        }
    },
    computed: {},
    watch: {},
    methods: {
        //复选框禁用
        selectable(row, rowIndex) {
            if (this.detailLinkList.findIndex(n => n.orderId === row.id) === -1) {
                return true;  //不禁用
            } else {
                return false;  //禁用
            }
        },
        save() {
            if (!this.multipleSelection.length) {
                this.$message.warning('请选择关联数据')
                return
            }
            new Api("user").reLinkInvoice(this.multipleSelection, this.invoicingDetailId).then((res) => {
                if (res.status === 200) {
                    this.$message({
                        message: "关联成功",
                        type: "success",
                    });
                    this.getQueryDetailLink()
                    this.centerDialogVisible = false
                } else {
                    this.$message.error({ message: res.statusText });
                }
            });
        },
        loadTable(page, size) {
            this.pageRequest.page = page;
            this.pageRequest.size = size;
            this.getList()
        },
        resetClick() {
            this.pageRequest.q = {
                planId:null,
                chargingContent: '',//收款内容
                payDateStr: '',//收款时间
                payName: '',//付款方名称
                payType: '',//付款方式 1微信 2线下
                payPrice: null,//收款金额
            }
            this.pageRequest.page = 1
            this.getList()
        },
        close() {
            this.multipleSelection = []
            this.$emit('update')
        },
        getList() {
            this.loading = true
            new PayApi("pay").allCollectionList(this.pageRequest).then(res => {
                if (res.status === 200) {
                    this.tableData = res.data.records
                    this.total = res.data.total
                    this.tableData.forEach(e => {
                        if (e.status == 5) {
                            this.$set(e, 'payPrice', -e.payPrice)
                        }
                        //实际到帐金额
                        this.$set(e, 'actualArrival', Number(e.payPrice) - Number(e.refundPrice))
                    })
                    this.tableData = this.tableData.filter(e => e.status != 5 && ((Number(e.payPrice) - Number(e.refundPrice) - Number(e.invoicePrice)) > 0))

                    //切换页面如果有勾选默认勾选上
                    this.multipleSelection.forEach(items => {
                        const idx = this.tableData.findIndex(item => item.id === items.orderId);
                        if (idx !== -1) {
                            this.$nextTick(() => {
                                this.$refs.multipleTable.toggleRowSelection(this.tableData[idx], true);
                            })
                        }
                    });
                    this.loading = false
                } else {
                    this.loading = false
                }
            })
        },
        //删除关联
        deleteLink(row) {
            new Api("user").deleteDetailLink([row.id]).then((res) => {
                if (res.status === 200) {
                    this.$message({
                        message: "删除成功",
                        type: "success",
                    });
                    this.getQueryDetailLink()
                } else {
                    this.$message.error({ message: res.statusText });
                }
            });
        },
        openDialog(id, price,planId) {
            this.pageRequest.q.planId = planId
            this.price = Number(price)
            this.invoicingDetailId = id
            this.centerDialogVisible = true
            this.getQueryDetailLink()
            this.getList()
        },
        getQueryDetailLink() {
            new Api("user")
                .queryDetailLink(this.invoicingDetailId)
                .then((res) => {
                    if (res.status == 200) {
                        this.detailLinkList = res.data
                    } else {
                        this.$message.error({ message: res.statusText });
                    }
                });
        },
        handleSelectionChange(val) {

            if (val.length > 0) {
                val.forEach((row) => {
                    let obj = {
                        price: Number(row.payPrice - Number(row.refundPrice)) - Number(row.invoicePrice),
                        orderId: row.id
                    }
                    this.multipleSelection.push(obj)
                })
                this.multipleSelection = uniqueByProperty(this.multipleSelection, 'orderId')
            } else {
                this.multipleSelection = this.multipleSelection.filter(n => !this.tableData.map(m => m.id).includes(n.orderId));
            }

        },
        //单选勾选
        handlerSelectChange(rowList, row) {
            let obj = {
                price: Number(row.payPrice - Number(row.refundPrice)) - Number(row.invoicePrice),
                orderId: row.id
            }
            if (this.multipleSelection.findIndex(n => n.orderId === row.id) === -1) {
                this.multipleSelection.push(obj)
            } else {
                this.multipleSelection.splice(this.multipleSelection.findIndex(n => n.orderId === row.id), 1)
            }
        },
    },
    created() {

    },
}
</script>
<style lang='scss' scoped>
.header {
    display: flex;
    align-items: center;
    color: #53B0A3;
    margin-bottom: 0.2rem;

    .headerP1 {
        margin-right: 0.2rem;
    }
}
</style>